export default __webpack_public_path__ + "static/media/privilege-gift-yellow.651b2c0a.svg";